import buildLocalizeFn from '../../../_lib/buildLocalizeFn/index'

const eraValues = {
  narrow: ['K', 'B'],
  abbreviated: ['KK', 'BK'],
  wide: ['Kabla ya Kristo', 'Baada ya Kristo'],
}

const quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Robo ya 1', 'Robo ya 2', 'Robo ya 3', 'Robo ya 4'],
  wide: ['Robo ya 1', 'Robo ya 2', 'Robo ya 3', 'Robo ya 4'],
}

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: [
    'Jan',
    'Feb',
    'Mac',
    'Apr',
    'Mei',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Okt',
    'Nov',
    'Des',
  ],
  wide: [
    'Januari',
    'Februari',
    'Machi',
    'Aprili',
    'Mei',
    'Juni',
    'Julai',
    'Agosti',
    'Septemba',
    'Oktoba',
    'Novemba',
    'Desemba',
  ],
}

const dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: [
    'Jumapili',
    'Jumatatu',
    'Jumanne',
    'Jumatano',
    'Alhamisi',
    'Ijumaa',
    'Jumamosi',
  ],
  abbreviated: [
    'Jumapili',
    'Jumatatu',
    'Jumanne',
    'Jumatano',
    'Alhamisi',
    'Ijumaa',
    'Jumamosi',
  ],
  wide: [
    'Jumapili',
    'Jumatatu',
    'Jumanne',
    'Jumatano',
    'Alhamisi',
    'Ijumaa',
    'Jumamosi',
  ],
}

const dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'usiku',
    noon: 'mchana',
    morning: 'alfajiri',
    afternoon: 'mchana',
    evening: 'jioni',
    night: 'usiku',
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'saa sita za usiku',
    noon: 'adhuhuri',
    morning: 'alfajiri',
    afternoon: 'alasiri',
    evening: 'jioni',
    night: 'usiku',
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'saa sita za usiku',
    noon: 'saa sita za mchana',
    morning: 'alfajiri',
    afternoon: 'mchana',
    evening: 'jioni',
    night: 'usiku',
  },
}

const formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'usiku',
    noon: 'mchana',
    morning: 'alfajiri',
    afternoon: 'mchana',
    evening: 'jioni',
    night: 'usiku',
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'saa sita za usiku',
    noon: 'adhuhuri',
    morning: 'alfajiri',
    afternoon: 'mchana',
    evening: 'jioni',
    night: 'usiku',
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'saa sita za usiku',
    noon: 'saa sita za mchana',
    morning: 'alfajiri',
    afternoon: 'mchana',
    evening: 'jioni',
    night: 'usiku',
  },
}

const ordinalNumber = (
  dirtyNumber,
  _options
) => {
  return String(dirtyNumber)
}

const localize = {
  ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide',
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: (quarter) => (quarter - 1),
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide',
  }),
}

export default localize
